export default __webpack_public_path__ + "源.png";